import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@ordr-as/icons'
import JsonHighlight from '../../../components/JsonHighlight'
import { PspRequestResponseDto } from '../../../../generated-api'

const PspRequestsResponses = ({ requestsAndResponses }: { requestsAndResponses: PspRequestResponseDto[] }) => {
    const mapTypeToLabel = (type: string): string => {
        return type
    }

    const parsePayload = (payload: string) => JSON.parse(payload)

    return (
        <div className="mt-6">
            <h2 className="text-xl mb-1">Requests and responses</h2>
            {requestsAndResponses.map((item, idx) => (
                <Disclosure key={idx}>
                    {({ open }) => (
                        <div
                            key={idx}
                            className={`${
                                idx !== requestsAndResponses.length - 1 ? 'border-b border-grey-lightest' : 'border-0'
                            } py-2`}
                        >
                            <Disclosure.Button className="font-semibold flex justify-between w-full items-center">
                                <span className={`${open ? 'text-brand-primary' : ''} transition-colors`}>
                                    {mapTypeToLabel(item.type)}
                                </span>
                                <ChevronDownIcon
                                    className={`${
                                        open ? 'transform rotate-180' : ''
                                    } transition-transform text-brand-primary`}
                                />
                            </Disclosure.Button>
                            <Disclosure.Panel>
                                <div className="border-l-2 border-brand-primary ml-2 mt-2 mb-4 pl-2">
                                    <JsonHighlight object={parsePayload(item.payload)} />
                                </div>
                            </Disclosure.Panel>
                        </div>
                    )}
                </Disclosure>
            ))}
        </div>
    )
}

export default PspRequestsResponses
